import React from 'react'
import {
  FormInputSelect,
  FormInput
} from 'camino-react'
import _ from 'lodash'

class Status extends React.Component {
  constructor (props) {
    super()
  }

  showticketResolved = (statusId) => {
    const { resolvedStatuses, setIsTicketStatusResolved } = this.props
    setIsTicketStatusResolved(_.includes(resolvedStatuses, statusId))
  }

  showTicketOnHold = (statusId) => {
    const { onHoldStatuses, setIsTicketStatusOnHold } = this.props
    setIsTicketStatusOnHold(_.includes(onHoldStatuses, statusId))
  }

  render () {
    const { editedItem, statuses } = this.props

    const {
      showTicketOnHold,
      showticketResolved
    } = this

    return (
      <div>
        <FormInput>
          <div key={editedItem.firstValueId}>
            <div>
              <FormInputSelect
                value={_.find(statuses, ({ value: editedItem.statusId }))}
                isLoading={_.isEmpty(statuses)}
                options={statuses}
                onValue={(value) => {
                  editedItem.updateOptionValue('statusId', value)
                  showticketResolved(value)
                  showTicketOnHold(value)
                }}
                clearable
                name="editedItem[statusId]"
                id="statusId"
              />
            </div>
          </div>
        </FormInput>

      </div>
    )
  }
}
export default Status
